import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const RadioGroupWrapper = styled.div`
  /* border: 1px solid red; */
  margin-bottom: 7.5px;
  font-family: ${props => props.theme.fonts.fontfaceBeta};
  text-transform: capitalize;

  label {
    margin-left: 7.5px;
    vertical-align: middle;
    /* border: 1px solid red; */
  }
`;

class RadioGroup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: this.props.active
    };
  }

  handleChange(event) {
    const value = event.target.value;
    this.setState({ active: value });
    this.props.onChange(value);
  }

  renderRadioItems(name, items) {
    return items.map(item => {
      const value = item.value;
      const checked = value === this.props.active;

      return (
        <RadioGroupWrapper key={value}>
          <input
            tabIndex={this.props.tabindex}
            className="inline"
            type="radio"
            value={value}
            name={name}
            id={value}
            checked={checked}
            onChange={value => this.handleChange(value)}
          />
          <label className="inline" htmlFor={value}>
            {item.label}
          </label>
        </RadioGroupWrapper>
      );
    });
  }

  render() {
    return (
      <Fragment>
        {this.renderRadioItems(this.props.name, this.props.items)}
      </Fragment>
    );
  }
}

RadioGroup.defaultProps = {
  tabindex: -1
};

RadioGroup.propTypes = {
  onChange: PropTypes.func,
  active: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.number.isRequired
  ]),
  name: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired
};

export default RadioGroup;



// WEBPACK FOOTER //
// ./src/components/RadioGroup/RadioGroup.js